import React from 'react';
import { Link } from 'react-router-dom';
import { useAcademy } from '../AcademyContext';
import ProgressBar from './ProgressBar';
import { IconCheck, IconVideo, IconQuiz } from './Icons';

const MAX_PREVIEW = 3;

const CourseCard = ({ topicId, course, accent }) => {
  const { getCourseProgress, isLessonDone, lessonType } = useAcademy();
  const { done, total, isComplete } = getCourseProgress(topicId, course);

  const lessonCount = course.lessons.length;
  const videoCount = course.lessons.filter((l) => lessonType(l) === 'video').length;
  const exerciseCount = course.lessons.filter((l) => lessonType(l) !== 'video').length;
  const previewLessons = course.lessons.slice(0, MAX_PREVIEW);
  const remaining = lessonCount - previewLessons.length;

  return (
    <Link
      to={`/academy/${topicId}/${course.id}`}
      className="ac-course-card"
      style={{ '--ac-card-accent': accent }}
    >
      <div className="ac-course-cover">
        <img src={course.cover} alt={course.title} className="ac-course-cover-img" />
        <span className="ac-course-cover-shade" />
        <span className="ac-course-cover-count">
          <IconVideo size={13} /> {lessonCount} {lessonCount === 1 ? 'lesson' : 'lessons'}
        </span>
      </div>

      <div className="ac-course-card-body">
        <h3 className="ac-course-card-title">{course.title}</h3>
        <p className="ac-course-card-sub">{course.subtitle}</p>

        <ul className="ac-course-contents">
          {previewLessons.map((lesson, i) => {
            const lessonDone = isLessonDone(topicId, course.id, lesson);
            return (
              <li key={lesson.id} className="ac-course-content-row">
                <span className={`ac-course-content-no ${lessonDone ? 'is-done' : ''}`}>
                  {lessonDone ? <IconCheck size={11} /> : i + 1}
                </span>
                <span className="ac-course-content-title">{lesson.title}</span>
                <span className="ac-course-content-dur">{lesson.duration}</span>
              </li>
            );
          })}
          {remaining > 0 && (
            <li className="ac-course-content-more">
              + {remaining} more {remaining === 1 ? 'lesson' : 'lessons'}
            </li>
          )}
        </ul>

        <div className="ac-course-card-foot">
          <span className="ac-course-card-meta">
            <span className="ac-course-card-metaitem">
              <IconVideo size={14} /> {videoCount}
            </span>
            {exerciseCount > 0 && (
              <span className="ac-course-card-metaitem">
                <IconQuiz size={14} /> {exerciseCount}
              </span>
            )}
            {isComplete && (
              <span className="ac-badge is-complete">
                <IconCheck /> Completed
              </span>
            )}
          </span>
          <ProgressBar done={done} total={total} />
        </div>
      </div>
    </Link>
  );
};

export default CourseCard;
